import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/cn';

// A small StatCard for a stage strip: the count standing at a stage, one line saying
// what that means, and a few words of context. The border carries a hold or a failure.
export const stageTileVariants = cva(
  'flex min-w-0 flex-1 flex-col gap-1.5 rounded-[12px] border bg-dusq-grey950 px-3.5 py-3',
  {
    variants: {
      tone: {
        neutral: 'border-transparent',
        warning: 'border-dusq-warning/40',
        negative: 'border-dusq-negative/40',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
);

const VALUE_TONE = {
  warning: 'text-dusq-warning',
  negative: 'text-dusq-negative',
  neutral: 'text-dusq-emphasis-high',
};

export const StageTile = React.forwardRef(
  ({ className, name, value, what, meta, tone = 'neutral', ...props }, ref) => (
    <div ref={ref} className={cn(stageTileVariants({ tone }), className)} {...props}>
      <span className="truncate font-dusq text-[12px] font-medium text-dusq-text">{name}</span>
      <span
        className={cn(
          'font-display text-[28px] font-semibold leading-[1.1]',
          VALUE_TONE[tone] || VALUE_TONE.neutral
        )}
      >
        {value}
      </span>
      {what && (
        <span className="font-dusq text-[11px] leading-[1.35] text-dusq-emphasis-disabled">
          {what}
        </span>
      )}
      {meta && (
        <span className="mt-0.5 font-dusq text-[11px] leading-[1.45] text-dusq-grey400">
          {meta}
        </span>
      )}
    </div>
  )
);
StageTile.displayName = 'StageTile';
